<div class="payment-result cancel">

  <div class="icon-circle">
    <i class="fa-solid fa-ban"></i>
  </div>

  <h1>{{ t('paymentCancelTitle') }}</h1>

  <p>{{ t('paymentCancelDesc') }}</p>

  <div class="actions">
    <a routerLink="/checkout" class="btn primary">{{ t('placeOrder') }}</a>
    <a routerLink="/" class="btn">{{ t('backToHome') }}</a>
  </div>

</div>
